(function () {
  const isMobile = window.innerWidth < 767;

  if (!customElements.get('product-modal')) {
    if (isMobile) {
      // class ProductModal extends HTMLElement {
      //   constructor() {
      //     super();
      //     this.dialog = null;
      //     this.content = null;
      //     this.closeButton = null;
      //     this.activeIndex = 0;
      //     this.initialized = false;
      //   }

      //   connectedCallback() {
      //     if (this.initialized) return;

      //     this.dialog = this.querySelector('.product-media-modal__dialog');
      //     this.content = this.querySelector('.product-media-modal__content');
      //     this.closeButton = this.querySelector('.product-media-modal__toggle');

      //     if (this.closeButton) {
      //       this.closeButton.addEventListener('click', this.hide.bind(this));
      //     }

      //     this.addNavigation();
      //     this.initialized = true;
      //   }

      //   show(mediaId = null) {
      //     this.style.display = 'block';
      //     this.setAttribute('open', '');

      //     if (mediaId) {
      //       const allMedia = this.querySelectorAll('[data-media-id]');
      //       const index = Array.from(allMedia).findIndex(el => el.getAttribute('data-media-id') === mediaId);
      //       if (index !== -1) this.goToSlide(index);
      //     }
      //   }

      //   hide() {
      //     this.style.display = 'none';
      //     this.removeAttribute('open');
      //   }

      //   addNavigation() {
      //     const leftBtn = document.createElement('button');
      //     const rightBtn = document.createElement('button');
      //     leftBtn.innerHTML = '&#10094;';
      //     rightBtn.innerHTML = '&#10095;';
      //     leftBtn.className = 'modal-slider-prev';
      //     rightBtn.className = 'modal-slider-next';

      //     const navStyle = {
      //       position: 'absolute',
      //       top: '50%',
      //       transform: 'translateY(-50%)',
      //       background: 'rgba(0,0,0,0.5)',
      //       color: 'white',
      //       fontSize: '2rem',
      //       border: 'none',
      //       zIndex: '10000',
      //       padding: '0.5rem',
      //       cursor: 'pointer'
      //     };

      //     Object.assign(leftBtn.style, navStyle, { left: '10px' });
      //     Object.assign(rightBtn.style, navStyle, { right: '10px' });

      //     this.appendChild(leftBtn);
      //     this.appendChild(rightBtn);

      //     leftBtn.addEventListener('click', () => this.goToSlide(this.activeIndex - 1));
      //     rightBtn.addEventListener('click', () => this.goToSlide(this.activeIndex + 1));
      //   }

      //   goToSlide(index) {
      //     const mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
      //     if (index < 0 || index >= mediaItems.length) return;

      //     mediaItems.forEach((item, i) => {
      //       item.style.display = i === index ? 'block' : 'none';
      //     });

      //     this.activeIndex = index;
      //   }
      // }

      // customElements.define('product-modal', ProductModal);
      class ProductModal extends HTMLElement {
      constructor() {
        super();
        this.dialog = null;
        this.content = null;
        this.closeButton = null;
        this.activeIndex = 0;
        this.initialized = false;
      }

      connectedCallback() {
        if (this.initialized) return;

        this.dialog = this.querySelector('.product-media-modal__dialog');
        this.content = this.querySelector('.product-media-modal__content');
        this.closeButton = this.querySelector('.product-media-modal__toggle');

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.hide.bind(this));
        }

        // Ensure 1st slide visible at init (safety)
        this.ensureInitialVisibility();

        this.addNavigation();
        this.initialized = true;
      }

      getMediaItems() {
        // All media inside modal that carry data-media-id
        return Array.from(this.querySelectorAll('[data-media-id]'));
      }

      findIndexByMediaId(id) {
        const items = this.getMediaItems();
        return items.findIndex(el => el.getAttribute('data-media-id') === id);
      }

      findSelectedIndex() {
        const items = this.getMediaItems();
        // Try .is-selected (common pattern), else first visible, else 0
        let idx = items.findIndex(el => el.classList.contains('is-selected'));
        if (idx !== -1) return idx;

        idx = items.findIndex(el => {
          const d = getComputedStyle(el).display;
          return d !== 'none';
        });
        if (idx !== -1) return idx;

        return 0;
      }

      ensureInitialVisibility() {
        const items = this.getMediaItems();
        if (!items.length) return;

        // If none visible, show first
        const anyVisible = items.some(el => getComputedStyle(el).display !== 'none');
        if (!anyVisible) {
          items.forEach((el, i) => {
            el.style.display = i === 0 ? 'block' : 'none';
          });
          this.activeIndex = 0;
        } else {
          // Track current visible index if exists
          const current = items.findIndex(el => getComputedStyle(el).display !== 'none');
          this.activeIndex = current >= 0 ? current : 0;
        }
      }

      show(mediaId = null) {
        // Open modal
        this.style.display = 'block';
        this.setAttribute('open', '');
        this.offsetWidth;

        // Resolve target index
        let index = this.activeIndex;
        if (mediaId) {
          const found = this.findIndexByMediaId(mediaId);
          if (found !== -1) index = found;
        } else {
          index = this.findSelectedIndex();
        }

        this.goToSlide(index);
      }

      hide() {
        this.style.display = 'none';
        this.removeAttribute('open');
      }

      addNavigation() {
        const leftBtn = document.createElement('button');
        const rightBtn = document.createElement('button');
        leftBtn.innerHTML = '&#10094;';
        rightBtn.innerHTML = '&#10095;';
        leftBtn.className = 'modal-slider-prev';
        rightBtn.className = 'modal-slider-next';

        const navStyle = {
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'rgba(0,0,0,0.5)',
          color: 'white',
          fontSize: '2rem',
          border: 'none',
          zIndex: '10000',
          padding: '0.5rem',
          cursor: 'pointer'
        };

        Object.assign(leftBtn.style, navStyle, { left: '10px' });
        Object.assign(rightBtn.style, navStyle, { right: '10px' });

        this.appendChild(leftBtn);
        this.appendChild(rightBtn);

        leftBtn.addEventListener('click', () => this.goToSlide(this.activeIndex - 1));
        rightBtn.addEventListener('click', () => this.goToSlide(this.activeIndex + 1));
      }

      goToSlide(index) {
        const items = this.getMediaItems();
        if (!items.length) return;

        if (index < 0) index = 0;
        if (index >= items.length) index = items.length - 1;

        items.forEach((item, i) => {
          item.style.display = i === index ? 'block' : 'none';
          item.classList.toggle('is-active', i === index);
          const img = item.querySelector('img[data-src]');
          if (i === index && img && !img.src) {
            img.src = img.getAttribute('data-src');
          }
        });

        this.activeIndex = index;
      }
    }

    customElements.define('product-modal', ProductModal);
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-open-modal][data-media-id]');
      if (!trigger) return;

      const mediaId = trigger.getAttribute('data-media-id');
      const modal = document.querySelector('product-modal');
      if (modal) {
        modal.show(mediaId); 
      }
    });

    } else {
      // Desktop version
      customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
    }
  }
})();
